import Animation from "Shared/components/animation";
import InlineSvg from "Shared/components/inline-svg";
import styles from "./status-message.css";
import { StatusMessageType } from "Shared/util/custom-hooks";
import { ReactNode } from "react";
import React from "react";

export type MessageActionButtonType = {
  action: () => void,
  text: string
}

type StatusMessageComponentType = {
  clearStatus?: () => void;
  className?: string;
  hideButton?: boolean;
  status: StatusMessageType;
  text: ReactNode;
  actionButton?: MessageActionButtonType;
};

const StatusMessage = ({
  clearStatus,
  className,
  hideButton,
  status,
  text,
  actionButton
}: StatusMessageComponentType) => {
  const getClassName = (messageStatus: StatusMessageType) => {
    switch (messageStatus) {
      case "SUCCEEDED":
        return styles.succeeded;
      case "FAILED":
        return styles.failed;
      case "PENDING":
        return styles.pending;
      case "WARNING":
        return styles.warning;
      default:
        return styles.default;
    }
  };

  const getSvg = (status: StatusMessageType) => {
    switch (status) {
      case "SUCCEEDED":
        return "/success.svg";
      case "INFO":
        return "/information-filled.svg";
      default:
        return "/error.svg";
    }
  };

  return (
    <Animation
      className={`${styles.animationContainer} ${className || ""}`}
      show={status !== "NONE"}
      animation="slide_down"
    >
      <div
        className={`statusMessageContainer ${
          styles.mainContainer
        } ${getClassName(status)}`}
      >
        {!hideButton && (
          <button
            type="button"
            className={styles.closeContainer}
            onClick={clearStatus}
          >
            <InlineSvg src="/close.svg" />
          </button>
        )}
        <div className={styles.messageContainer}>
          <div className={styles.iconContainer}>
            <InlineSvg onClick={clearStatus} src={getSvg(status)} />
          </div>
          <div className={styles.messageTextContainer}>
            <div>{text}</div>
            {actionButton && (
              <button onClick={actionButton.action}>{actionButton.text}</button>
            )}
          </div>
        </div>
      </div>
    </Animation>
  );
};

export default StatusMessage;
